import { Injectable } from '@angular/core';
import { isBrowserContext, Nillable } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly _localStorage = isBrowserContext() ? localStorage : null;

  public setItem(key: string, value: string): void {
    this._localStorage?.setItem(key, value);
  }

  public getItem(key: string): Nillable<string> {
    return this._localStorage?.getItem(key);
  }

  public removeItem(key: string): void {
    this._localStorage?.removeItem(key);
  }

  public isExists(key: string): boolean {
    try {
      return !!this.getItem(key);
    } catch (error) {
      return false;
    }
  }
}
